import { useEffect, useState } from "react";
import Map from "../../components/gMap/Map";
import { useNavigate } from "react-router-dom";
import "./liveTracking.css";

const Tracking = () => {
  const navigate = useNavigate();
  const [driverData, setDriverData] = useState<any>([]);
  const [VahicalInfo, setVahicalInfo] = useState<any>({});
  const [locationStatus, setLocationStatus] = useState<{isLoading: boolean; error: string}>({isLoading: true, error: ""});

  // const tracking = useSelector((state: RootState) => state.tracking);
  useEffect(() => {
    let query = window.location.search;
    if (!query) navigate("/dashboard");
    // The Map component owns the single-track request and its retry lifecycle.
  }, []);
  const getDriverData = (data: any) => {
    setDriverData(data);
  };

  return (
    <div style={{ display: "flex" }}>
      <Map setVahicalInfo={setVahicalInfo} bringDriverData={getDriverData} onLocationStatus={setLocationStatus} />
      <div className="main-container-track">
        <div className=" inside-container">
          <h5 className="tracking-text">Tracking Details</h5>
          {locationStatus.isLoading ? <p role="status">Loading latest vehicle location…</p> : null}
          {locationStatus.error ? <p role="alert">{locationStatus.error}</p> : null}
          {driverData ? (
            <>
              <p>
                Vehicle Reg. No:{" "}
                <span className="track-data">{VahicalInfo?.sRegNo || "—"}</span>
              </p>
              {VahicalInfo.sTemperature ? (
                <p>
                  Temperature :{" "}
                  <span className="track-data">
                    {VahicalInfo.sTemperature}°C
                  </span>
                </p>
              ) : null}

              {VahicalInfo.sHalt ? (
                <p>
                  Halted Since:{" "}
                  <span className="track-data">{VahicalInfo.sHalt}</span>
                </p>
              ) : null}
              {VahicalInfo.sLocation ? (
                <p>
                  Location:{" "}
                  <span className="track-data">{VahicalInfo.sLocation}</span>
                </p>
              ) : null}

              <p>
                Driver Name:{" "}
                <span className="track-data">{driverData?.tAssignDriver?.sName || "—"}</span>
              </p>
              <p>
                Driver Contact :{" "}
                <span className="track-data">
                  {driverData?.tAssignDriver?.aPhoneNo || "—"}
                </span>
              </p>

              <p>
                Driver Address :{" "}
                <span className="track-data">
                  {driverData?.tAssignDriver?.sPresentAddress || "—"}
                </span>
              </p>
            </>
          ) : (
            "Fetching data.."
          )}
        </div>
      </div>
    </div>
  );
};

export default Tracking;
